
    import './styles.scoped.css';
    export default {
  "row": "awsui_row_3yyds_j0dpc_5",
  "row-grid": "awsui_row-grid_3yyds_j0dpc_10"
};
  